// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1Ui3i","addWidgetButton":"Header_addWidgetButton__2PWbV","dashboardTabs":"Header_dashboardTabs__1iLWf","active":"Header_active__3i3VO"};